import React from 'react';
import {
	Dialog,
	DialogContent,
	Grid,
	Typography,
	IconButton as MaterialIconButton,
	Button,
	CircularProgress,
} from '@mui/material';
import {
	CircleClose,
	CloseIcon,
	GreenTickIcon,
	UploadIcon,
} from '../assets/icons/Icons';
import IconButton from './IconButton';
import { FileUploadDiv, helperText } from '../assets/theme/Theme';
import Dropzone from 'react-dropzone';
import TextInput from './TextInput';
import FileContentTile from './FileContentTile';

function OptionPopup({
	isModalOpen,
	onClose,
	popupTitle,
	isTypeUpload,
	readTextFile,
	txt,
	txtError,
	values,
	onChange,
	apiError,
	popupBtnState,
	onClickBtn,
	onRemoveFiles,
	loading,
}) {
	function renderDialogContent() {
		if (isTypeUpload) {
			return (
				<>
					<Grid container paddingX={'15px'}>
						<Grid
							container
							paddingTop={'20px'}
							flexDirection={'column'}>
							<Typography
								fontSize={'16px'}
								width={'100%'}
								color={'#7C7C7C'}
								marginBottom={'5px'}>
								Upload if any previous care plan files for the
								resident
							</Typography>
						</Grid>
						<Dropzone
							onDrop={acceptedFiles =>
								readTextFile(acceptedFiles)
							}>
							{({ getRootProps, getInputProps }) => (
								<section style={{ width: '100%' }}>
									<div
										{...getRootProps()}
										style={{
											...FileUploadDiv,
											border: txtError.status
												? '1px dashed red'
												: FileUploadDiv.border,
										}}>
										<input {...getInputProps()} />
										<UploadIcon />
										<br />
										<>
											<Typography
												fontSize={'16px'}
												fontWeight={'700'}
												color={'#7C7C7C'}>
												Upload care plan details
											</Typography>
											<Typography
												fontSize={'14px'}
												color={'#B4B2B2'}>
												Maximum upload file size: 5MB
											</Typography>
										</>
									</div>
									<Grid
										container
										alignItems="center"
										spacing={2}>
										{txt.map((file, index) => (
											<Grid
												item
												xs={6}
												sm={4}
												md={4}
												key={index}>
												<FileContentTile
													file={file}
													onRemoveFiles={
														onRemoveFiles
													}
												/>
											</Grid>
										))}
									</Grid>
								</section>
							)}
						</Dropzone>
						<Typography sx={[helperText, { marginTop: '10px' }]}>
							{txtError.msg}
						</Typography>
					</Grid>
				</>
			);
		} else {
			return (
				<Grid container paddingX={'15px'}>
					<Grid
						container
						paddingTop={'20px'}
						flexDirection={'column'}>
						<Typography
							fontSize={'16px'}
							width={'15%'}
							color={'#7C7C7C'}
							marginBottom={'5px'}>
							Api url
						</Typography>
						<TextInput
							error={apiError.url?.status}
							width={'100%'}
							placeholder={'Enter api url'}
							value={values.url}
							onChange={value => onChange('url', value)}
						/>
						<Typography style={helperText}>
							{apiError.url.msg}
						</Typography>
					</Grid>
					<Grid
						container
						paddingTop={'20px'}
						flexDirection={'column'}>
						<Typography
							fontSize={'16px'}
							color={'#7C7C7C'}
							width={'15%'}
							marginBottom={'5px'}>
							Api Token
						</Typography>
						<TextInput
							error={apiError.url?.status}
							width={'100%'}
							placeholder={'Enter api token'}
							value={values.token}
							onChange={value => onChange('token', value)}
						/>
						<Typography style={helperText}>
							{apiError.token.msg}
						</Typography>
					</Grid>
				</Grid>
			);
		}
	}

	return (
		<>
			<Dialog open={isModalOpen} onClose={onClose} scroll="body">
				<DialogContent style={{ padding: '0px 0px 20px 0px' }}>
					<Grid
						container
						sx={{ boxShadow: 3 }}
						padding={'10px'}
						flexDirection={'row'}
						justifyContent={'space-between'}
						alignItems={'center'}>
						<Typography fontWeight={'600'}>{popupTitle}</Typography>
						<MaterialIconButton
							style={{ padding: '0' }}
							onClick={onClose}>
							<CloseIcon />
						</MaterialIconButton>
					</Grid>
					<Grid container padding={'10px'}>
						{renderDialogContent()}
					</Grid>
					<Grid
						container
						justifyContent={'flex-end'}
						paddingTop={'10px'}
						paddingX={'20px'}>
						{loading && (
							<Grid paddingRight={'10px'} paddingTop={'5px'}>
								<CircularProgress
									sx={{ color: '#28696D' }}
									size={'2rem'}
								/>
							</Grid>
						)}
						<Button
							onClick={onClose}
							sx={{
								border: '2px solid #28696D',
								paddingLeft: '15px',
								paddingRight: '15px',
								color: '#28696D',
								textTransform: 'none',
								marginRight: '10px',
							}}>
							{'Cancel'}
						</Button>
						<IconButton text={popupBtnState} onClick={onClickBtn} />
					</Grid>
				</DialogContent>
			</Dialog>
		</>
	);
}

export default OptionPopup;
